import React, { useState, useEffect, useRef } from 'react';

// Remove priceDisplayStyles completely as we're now using TradeDesk.css

const PriceDisplay = ({ 
  market, 
  displayPrice, 
  displayBid, 
  displayAsk, 
  previousClose,
  formatCurrency,
  priceFlashClass,
  bidFlashClass,
  askFlashClass,
  marketFlashClass
}) => {
  // For debugging
  useEffect(() => {
    // console.log('PriceDisplay received values:', { 
    //   displayPrice, 
    //   displayBid, 
    //   displayAsk,
    //   bid: typeof displayBid, 
    //   ask: typeof displayAsk,
    //   price: typeof displayPrice
    // });
  }, [displayPrice, displayBid, displayAsk]);

  // Calculate price percent change
  const calculatePercentChange = () => {
    if (!previousClose || previousClose === 0 || !displayPrice || isNaN(displayPrice) || isNaN(previousClose)) {
      return null;
    }
    const percentChange = ((displayPrice - previousClose) / previousClose) * 100;
    return isNaN(percentChange) ? null : percentChange.toFixed(2);
  };

  // Helper to safely format currency values
  const safeFormatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }
    const formatted = formatCurrency(value);
    return formatted === 'NaN' ? '' : formatted;
  };

  // Format all the currency values
  const formattedBid = safeFormatCurrency(displayBid);
  const formattedAsk = safeFormatCurrency(displayAsk);
  const formattedPrice = safeFormatCurrency(displayPrice);
  
  // Consider price valid if it's a non-zero number and we have a formatted string
  const isPriceValid = 
    displayPrice !== null && 
    displayPrice !== undefined && 
    !isNaN(displayPrice) && 
    displayPrice !== 0 && 
    formattedPrice !== '';
  
  // Calculate percent change only if price is valid
  const pricePercentChange = calculatePercentChange();

  if (!market) {
    return (
      <div className="td-header">
        <div>Select a market to trade</div>
      </div>
    );
  }

  return (
    <div className="td-header">
      <div className="td-symbol-wrapper">
        <div className={`td-symbol ${marketFlashClass}`}>{market.name}</div>
        <div className="td-description">{market.description || 'Dollar vs Swiss Franc'}</div>
      </div>
      
      {/* Always show price section - either filled or blank */}
      <div className="td-price-display">
        <div className="td-current-price-wrapper">
          <span className={`td-current-price ${priceFlashClass}`}>
            {formattedPrice}
          </span>
          {pricePercentChange && (
            <span className={`td-price-change ${pricePercentChange >= 0 ? 'td-price-change-positive' : 'td-price-change-negative'}`}>
              {pricePercentChange >= 0 ? '' : '↓'}{Math.abs(parseFloat(pricePercentChange)).toFixed(2)}%
            </span>
          )}
        </div>
      </div>
      
      <div className="td-prices-container">
        <div className="td-bid-column">
          <div className="td-bid-label">BID</div>
          <div className={`td-bid-value ${bidFlashClass}`}>{formattedBid}</div>
        </div>
        <div className="td-ask-column">
          <div className="td-ask-label">ASK</div>
          <div className={`td-ask-value ${askFlashClass}`}>{formattedAsk}</div>
        </div>
      </div>
    </div>
  );
};

export default PriceDisplay; 